export const MAX_BALANCE_EXPIRY_TIMER_MS=2_147_483_647;
export interface BalanceExpiryEnvironment {
 now:()=>number;
 visible:()=>boolean;
 after:(callback:()=>void,milliseconds:number)=>()=>void;
 onFocus:(callback:()=>void)=>()=>void;
 onVisibility:(callback:()=>void)=>()=>void;
}
function browserEnvironment():BalanceExpiryEnvironment{return {
 now:Date.now,
 visible:()=>document.visibilityState==='visible',
 after:(callback,milliseconds)=>{const timer=window.setTimeout(callback,milliseconds);return()=>window.clearTimeout(timer);},
 onFocus:callback=>{window.addEventListener('focus',callback);return()=>window.removeEventListener('focus',callback);},
 onVisibility:callback=>{document.addEventListener('visibilitychange',callback);return()=>document.removeEventListener('visibilitychange',callback);},
};}
/** This schedules authoritative reads only. It never changes money or submits work. */
export function watchBalanceExpiry(expiresAt:string|null|undefined,refresh:()=>void,environment:BalanceExpiryEnvironment=browserEnvironment()):()=>void {
 const expiry=expiresAt?Date.parse(expiresAt):NaN;
 let stopped=false,fired=false,cancelTimer:(()=>void)|null=null,removeFocus:(()=>void)|null=null;
 function clear(){cancelTimer?.();cancelTimer=null;removeFocus?.();removeFocus=null;}
 function arm(){
  cancelTimer?.();cancelTimer=null;if(stopped||!environment.visible()||!Number.isFinite(expiry)||fired)return;
  cancelTimer=environment.after(()=>{cancelTimer=null;if(stopped||!environment.visible())return;if(environment.now()>=expiry){fired=true;refresh();}else arm();},Math.min(MAX_BALANCE_EXPIRY_TIMER_MS,Math.max(0,expiry-environment.now())));
 }
 function focused(){if(!stopped&&environment.visible()){if(Number.isFinite(expiry)&&environment.now()>=expiry)fired=true;refresh();arm();}}
 function visibilityChanged(){clear();if(stopped||!environment.visible())return;removeFocus=environment.onFocus(focused);focused();}
 if(environment.visible()){removeFocus=environment.onFocus(focused);arm();}
 const removeVisibility=environment.onVisibility(visibilityChanged);
 return()=>{if(stopped)return;stopped=true;clear();removeVisibility();};
}
